import { GraphQLClient } from 'graphql-request';

import { getUserIdentifier } from 'utils/id';
import { getUrlParams } from 'utils/url';
import { getUserIdFromAuthCookie } from 'utils/user';

import waitTimesQuery from './waitTimesQuery';

const USER_ID_PARAM = 'userId';
const GRAPHQL_URL = `${process.env.REACT_APP_BASE_WAIT_TIME_AGGREGATOR_URL}/api/v1/graphql`;

export const getWaitTimes = async () => {
  const userIdentifier = getUserIdentifier().browserCookieId || getUserIdentifier().carvanaDeviceId;
  const userIdFromWebview = getUrlParams(USER_ID_PARAM);
  const userIdFromAuthCookie = getUserIdFromAuthCookie();

  const userId = userIdFromAuthCookie || userIdFromWebview;

  return new GraphQLClient(GRAPHQL_URL).request({
    document: waitTimesQuery,
    variables: {
      userProfile: {
        browserCookieId: userIdentifier,
        ...(userId && { userId }),
      },
    },
  });
};
